import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the api
 */
export class GPSFilteringService extends BaseService {

	constructor() {	
		super();
	}
	
	async getGPSFilters() {
		var data = await this.makeGETRequest('/api/resource/gps-filters');		
		return data;		
	}
	
	async getGPSFilter(id) {
		var data = await this.makeGETRequest('/api/resource/gps-filters/' + id);		
		return data;		
	}
	
	async saveGPSFilter(filter, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/gps-filters/' + filter.gpsFilterId, filter);
		} else {
			saved = await this.makePOSTRequest('/api/resource/gps-filters', filter);
		}
		return saved;		
	}	
	
	async deleteGPSFilter(gpsfilterId) {
		var data = await this.makeDELETERequest('/api/resource/gps-filters/' + gpsfilterId);		
		return data;		
	}
	
}
